import createIcon from '../../createIcon';

/**
 * @component @name Edit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi45OTkwMiAxNy4yNTA1VjIxLjAwMDVINi43NDkwMkwxNy44MDkgOS45NDA1NUwxNC4wNTkgNi4xOTA1NUwyLjk5OTAyIDE3LjI1MDVaTTIwLjcwOSA3LjA0MDU1QzIxLjA5OSA2LjY1MDU1IDIxLjA5OSA2LjAyMDU1IDIwLjcwOSA1LjYzMDU1TDE4LjM2OSAzLjI5MDU1QzE3Ljk3OSAyLjkwMDU1IDE3LjM0OSAyLjkwMDU1IDE2Ljk1OSAzLjI5MDU1TDE1LjEyOSA1LjEyMDU1TDE4Ljg3OSA4Ljg3MDU1TDIwLjcwOSA3LjA0MDU1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Edit = createIcon('Edit', [
  [
    'path',
    {
      d: 'M2.99902 17.2505V21.0005H6.74902L17.809 9.94055L14.059 6.19055L2.99902 17.2505ZM20.709 7.04055C21.099 6.65055 21.099 6.02055 20.709 5.63055L18.369 3.29055C17.979 2.90055 17.349 2.90055 16.959 3.29055L15.129 5.12055L18.879 8.87055L20.709 7.04055Z',
      key: 'cjks89',
    },
  ],
]);

export default Edit;
